import { useFeatureFlags } from "@partners/ui";
import { useGetUserSuspenseQueryOptions } from "@partners/ui/api";
import { useSuspenseQueries } from "@tanstack/react-query";
import { useRouterState } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { useIBOnboardingStateCheck } from "@/hooks/useIBOnboardingStateCheck";

import { AuthenticatedBaseHeader } from "./AuthenticatedBaseHeader";
import { getNavLinks, getNavLinksOverviewOnly } from "./getNavLinks";
import { ProfileMenuWithTriage } from "./ProfileMenuWithTriageWrapper";

export const AuthenticatedHeaderIBApplicationNotComplete = () => {
  const { t } = useTranslation();
  const { location } = useRouterState();
  const {
    programSelectionPage,
    subIbCsvExportForMib,
    referralLinks,
    performanceReport,
  } = useFeatureFlags();
  const { isIBFromNewFlow } = useIBOnboardingStateCheck();
  const [userQuery] = useSuspenseQueries({
    queries: [
      {
        queryKey: useGetUserSuspenseQueryOptions().queryKey,
        queryFn: useGetUserSuspenseQueryOptions().queryFn,
      },
    ],
  });

  const profileMenu = (
    <ProfileMenuWithTriage
      onboardingState={userQuery.data.onboardingState}
      isMAMMaster={userQuery.data.isMAMMaster}
      isIdentityOnlyUser={false}
      userName={userQuery.data.name}
    />
  );

  const navLinks =
    programSelectionPage && isIBFromNewFlow
      ? getNavLinks(t, {
          showExportReport: subIbCsvExportForMib,
          referralLinks,
          showPerformanceReport: performanceReport,
        })
      : getNavLinksOverviewOnly(t);

  return (
    <AuthenticatedBaseHeader
      profileMenuComponent={profileMenu}
      navLinks={navLinks}
      selectedNavLink={location.pathname}
      launchPersonalTradingLinkLabel={t(
        "global_header_launchPersonalTrading_link",
      )}
      isIdentityOnlyUser={false}
    />
  );
};
